/* eslint no-useless-escape: "off" */
/* eslint @typescript-eslint/no-this-alias: "off" */
import { Component, HostListener, OnInit, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, RouterOutlet } from '@angular/router';
import { LoaderService } from 'app/services/loader.service';
import { AuthenticationService } from 'app/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  NoPortfolioModalComponent,
  MobileAppModalComponent,
  PgfAnnounceModalComponent,
  PgfWelcomeModalComponent,
  WelcomeNotificationModalComponent
} from 'app/components/CommonModals/CommonModals.component';
import { AppConfig } from "app/app.config";
import { APIService } from 'app/services/api.service';
import { NgClass } from '@angular/common';

// create toNWMdate method on String object to avoid timezone issues
// the issue we used to have is new Date('2019-01-01') is returning "Mon Dec 31 2018 16:00:00 GMT-0800 (Pacific Standard Time)"
// and getting year, for exemple, from this date would give you 2018 insted of 2019
declare global {
  interface String {
    toNWMdate(): Date;
  }

  interface Window {
    isMobileSafari: boolean;
    MSStream?: unknown;
    scrollable_scroll_timer: number;
    scroll_timer: number;
    scroll_timer2: number;
  }
}
// TODO: remove that code and replace it with a new module based on Luxon to parse/format dates
String.prototype.toNWMdate = function() {
  const d = new Date(this.toString());
  d.setTime( d.getTime() + d.getTimezoneOffset()*60*1000 );
  return d;
}

type welcomeMessageType = {
  body: string;
  title: string;
  id: number;
  type: string;
};

window['isMobileSafari'] = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) && /iPad|iPhone|iPod/.test(navigator.userAgent) && ! window['MSStream'];

@Component({
    selector: 'nwm-app',
    templateUrl: './app.component.html',
    imports: [NgClass, RouterOutlet]
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private loaderService = inject(LoaderService);
  private modalService = inject(NgbModal);
  private config = inject(AppConfig);
  private api = inject(APIService);
  private authService = inject(AuthenticationService);


  showLoader?: boolean;
  showLoaderTimer?: NodeJS.Timeout;
  previousUrl = '';
  showPage = false;
  modals : string[]  = [];
  welcomeMsg: welcomeMessageType[] = [];

  notificationMsg: string  = '';
  notifcationIds: number[] = [];
  notificationFlaggedMsg: string = '';

  ngOnInit() {

    this.authService.getReRg().subscribe(async reRg => {
      const user = this.authService.getUser();
      const last_login = user?.last_login || '';
      const pgfLaunchUtc = this.config.pgfLaunchUtc;
      if (user && user?.reRgs?.some(f => f.RergType === 'PGF') && last_login < pgfLaunchUtc) {
        const storage_flags = this.getStorageFlags(user.uId);
        if (reRg?.RergType === 'PGF' && !storage_flags.includes('PgfWelcomeModalShown')) {
          this.setStorageFlags(user.uId, 'PgfWelcomeModalShown');
          this.setStorageFlags(user.uId, 'PgfAnnounceModalShown');
          this.modals.push('PgfWelcomeModalComponent');
        } else if (reRg?.RergType !== 'PGF' && !storage_flags.includes('PgfAnnounceModalShown')) {
          this.setStorageFlags(user.uId, 'PgfAnnounceModalShown');
          this.modals.push('PgfAnnounceModalComponent');
        }
      }

      if (user && !user.roles.includes('Accountant') && localStorage.getItem('FirstLogin')) {
        if (!user.reRgs?.length) {
          this.modals.push('NoPortfolioModalComponent');
        }
        this.modals.push('MobileAppModalComponent');

        localStorage.removeItem('FirstLogin');
      }

      const navigateTo = sessionStorage.getItem('NavigateTo');
      if (navigateTo) { //no need to refresh current page if navigate somewhere else
        sessionStorage.removeItem('NavigateTo');
        this.router.navigate([navigateTo]);
      } else {
        this.showPage = false;
        setTimeout(() => {
          this.showPage = true
        });
      }

      if (reRg && !sessionStorage.getItem('isKYCredirect')) {
        await this.getWelcomeMsg().then(m => {
          if (m) this.modals.push('WelcomeNotificationModalComponent');
        });
      }
      this.openModals();
    })

    const so = this;
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationStart) {
        jQuery('body').removeClass('forceMenu');
        jQuery('body').removeClass('overlay');
        jQuery('.NWMchart-tooltip').hide();
      }

      if (evt instanceof NavigationEnd) {
        $('nwm-app').css({marginBottom:0});
        if ( this.previousUrl.indexOf('/portfolio') == -1 || evt.url.indexOf('/portfolio') == -1 ) { // scroll page to the top only if navigation is not inside portfolio page
          window.scrollTo(0, 0);
        }
        this.previousUrl = evt.url;
        $(window).trigger('resize');
      }
    });

    $(document).ready(function() {
      $(document).on('click', '[data-scrollTo] .page-link', function() {
        const menu_height = parseInt(window.getComputedStyle(document.getElementsByClassName('content')[0]).paddingTop);
        const y = $($(this).parents('[data-scrollTo]').attr('data-scrollTo')!).offset()!.top - menu_height;
        if (window.scrollY > y)
          $([document.documentElement, document.body]).animate({scrollTop:y}, 500);
      });
      /* password show/hide toggle */
      $(document).on('click', '.passwordEye', function() {
        const $this = $(this).parent().find('input[type=password],.passwordInput');
        if ( $this.attr('type') == 'password') {
          $this.attr('type','text').addClass('passwordInput');
          $(this).text('visibility_off');
        }
        else {
          $this.attr('type','password');
          $(this).text('visibility');
        }
      });

      $(document).on('click', '.scrollable-button', function() {
        const p = $(this).parents('.scrollable');
        const s = p.scrollLeft()! + p.width()! * .75 * ($(this).hasClass('left') ? -1 : 1);
        if( p.is(':animated') ) {
          p.finish().scrollLeft(s);
        } else {
          p.animate({'scrollLeft': s});
        }
      });
      $(window).on('resize scroll', function() {
        $('body').addClass('windowScrolling');
        if(window['scroll_timer']) {
          window.clearTimeout(window['scroll_timer']);
        }
        window['scroll_timer'] = window.setTimeout(function() {
          $('body').removeClass('windowScrolling');
          so.scrollable_resize($('.scrollable-wrap'));
        },100);
        if(window['scroll_timer2']) {
          window.clearTimeout(window['scroll_timer2']);
        }
        window['scroll_timer2'] = window.setTimeout(function() {
          so.sticky_header(document.getElementsByClassName('sticky_header'));
        },1);
      });
    });

    this.loaderService.status.subscribe((val: boolean) => {
      if (!this.showLoader && val) {
        this.showLoaderTimer = setTimeout(()=>{
          this.showLoader = true;
        },300);
      }
      if (!val) {
        this.showLoader = false;
        if (this.showLoaderTimer)
          clearTimeout(this.showLoaderTimer);
          setTimeout(()=>{
            this.showLoader = false;
          },300);
      }
    });

    this.loaderService.navigateTo.subscribe((tag: string) => {
      this.scrollTo(tag);
    });
  }

  getWelcomeMsg(): Promise<boolean> {
    return new Promise((resolve) => {
      this.api.get<welcomeMessageType[]>(this.config.profile.welcomeMsgUrl + '/' + this.authService.getCurrentReRg()!.ReRgId).subscribe(data => {
        this.notificationFlaggedMsg = '';
        this.notificationMsg = '';
        this.notifcationIds = [];

        data.forEach(d => {
          if (d.type === 'flagged') {
            this.notificationFlaggedMsg += d.body + '<br><br>';
          } else {
            this.notificationMsg  += '<b>' + d.title + '</b><br>' + d.body + '<br><br>';
            this.notifcationIds.push(d.id);
          }
        });
        resolve(!!this.notificationMsg || !!this.notificationFlaggedMsg);
      });
    });
  }

  openModals() {
    if (this.modals.length > 0) {
      const modal = this.modals.shift();
      let popUpModal = null;
      switch (modal) {
        case 'NoPortfolioModalComponent':
          popUpModal = NoPortfolioModalComponent;
          break;
        case 'MobileAppModalComponent':
          popUpModal = MobileAppModalComponent;
          break;
        case 'PgfAnnounceModalComponent':
          popUpModal = PgfAnnounceModalComponent;
          break;
        case 'PgfWelcomeModalComponent':
          popUpModal = PgfWelcomeModalComponent;
          break;
        case 'WelcomeNotificationModalComponent':
          popUpModal = WelcomeNotificationModalComponent;
          break;
      }
      const modalRef = this.modalService.open(popUpModal,{ centered: true, size: 'lg' });
      if (modal === 'WelcomeNotificationModalComponent') {
        modalRef.componentInstance.notificationMsg = this.notificationMsg;
        modalRef.componentInstance.nameId = this.authService.getCurrentReRg()!.ReRgId;
        modalRef.componentInstance.notifcationIds = this.notifcationIds;
        modalRef.componentInstance.notificationFlaggedMsg = this.notificationFlaggedMsg;
      }
      modalRef.dismissed.subscribe(()=>{
        this.openModals();
      });
    }
  }

  getStorageFlags(uId:string):string[] {
    const f = localStorage.getItem('flags');
    if (!f) return [];
    return JSON.parse(f)[uId] || [];
  }

  setStorageFlags(uId:string, flag:string) {
    const f = JSON.parse(localStorage.getItem('flags') || '{}');
    if (!f[uId]) f[uId] = [];
    if (!f[uId].includes(flag)) {
      f[uId].push(flag);
      localStorage.setItem('flags', JSON.stringify(f));
    }
  }

  @HostListener('document:click', ['$event'])
  click(event: MouseEvent) {

    const target = event.target as HTMLElement;

    /****** Closing datepickers ********/
    if ( (event.screenX != 0 || event.screenY != 0) && $(target).parents('ngb-datepicker').length == 0) {
      // event.screenX != 0 || event.screenY != 0 - helps to find out if it's an original event instead of jquery
      $('ngb-datepicker+div, .date-selector').each(function() {
        if (!this.contains(target) && (!$(this).hasClass('date-selector') || $(this).find('ngb-datepicker').length > 0 ) ) {
          $(this).trigger('click');
        } else if (this.contains(target) && !$(target).hasClass('fa-calendar') && $(this).hasClass('date-selector') && $(this).find('ngb-datepicker').length == 0) {
          $(this).find('.fa-calendar').click();
        }
      });
    }
    /******  /Closing datepickers *******/

  }

  sticky_header(e: HTMLCollectionOf<Element>){
    for (let i = 0; i<e.length; i++) {
      const el = e[i] as HTMLTableElement;
      const $this = $(el);

      let clone = $this.next('.sticky_header_clone') as JQuery<HTMLElement>;

      const rect = el.tHead!.getBoundingClientRect();
      const bottom = el.getBoundingClientRect().bottom;
      let menu_height = 0;
      if ($this.parents('.modal').length == 0) {
        menu_height = parseInt(window.getComputedStyle(document.getElementsByClassName('content')[0]).paddingTop);
        $('side-menu:not(.dont-indent-sticky-header) #side-menu-button:visible').each(function() {
          const r = this.getBoundingClientRect();
          if (r.top <=menu_height) {
            menu_height+=r.height;
          }
        });
      }

      if ( rect.top < menu_height && bottom > menu_height + rect.height) {
        const p = $this.parents('.scrollable-wrap');
        const left = (p.length > 0) ? p[0].getBoundingClientRect().left : rect.left;
        if (clone.length == 0) {
          const $origHeader = $this.find('thead');
          clone = $('<div class="sticky_header_clone">').insertAfter($this);
          clone.append($this.clone().removeClass('sticky_header'));
          clone.find('tbody').remove();
          clone.find('table').attr('width',rect.width+'px');
          if (p.length > 0) {
            const sl = p.find('.scrollable').scrollLeft();
            clone.find('table').css({'margin-left': (sl ? (0-sl)+'px' : '0')});
          }
          $origHeader.addClass('orig');
        }
        const h = clone.find('thead td, th');
        $this.find('thead td, th').each(function (i) {
          const t = $(this);
          $(h[i]).css({'width': t.outerWidth()!,'height': t.outerHeight()!});
          const a = t.find('a');
          if (a.length) {
            $(h[i]).find('a')[0].onclick = a[0].onclick;
          }
        });
        clone.css({ 'top':menu_height+'px',
                    'left': left + 'px',
                    'width': (p.length>0 ? p[0].getBoundingClientRect().width : rect.width)+'px',
                    'display':'block'});
        if ($this.find('thead').hasClass('orig')) {
          this.swapElements(clone.find('thead')[0], $this.find('thead')[0]);
        }
      } else {
        if (clone.length > 0) {
          if (clone.find('thead').hasClass('orig')) {
            this.swapElements(clone.find('thead')[0], $this.find('thead')[0]);
          }
          clone.css({'display': 'none'});
        }
      }
    }
  }

  swapElements(e1: HTMLElement, e2: HTMLElement) {
    const p1 = e1.parentNode as HTMLElement;
    const p2 = e2.parentNode as HTMLElement;
    p1.appendChild(e2);
    p2.appendChild(e1);
  }

  scrollable_resize(e: JQuery<HTMLElement>) {
    const so = this;
    e.each(function() {
      const $this = $(this as HTMLElement);

      if (!$this.hasClass('scrollable-enabled')) {
        $this.addClass('scrollable-enabled');
        $this.find('.scrollable').on('scroll', function() {
          const sl = $this.find('.scrollable').scrollLeft()!;
          const rect = this.getBoundingClientRect();
          $this.find('.sticky_header_clone').css({'left':rect.left+'px','width':rect.width+'px'});
          $this.find('.sticky_header_clone table').css('margin-left', sl==0 ? '0' : (0-sl)+'px');
          if(window['scrollable_scroll_timer']) window.clearTimeout(window['scrollable_scroll_timer']);
          window['scrollable_scroll_timer'] = window.setTimeout(function() {so.scrollable_resize($this)},100);
        });
      }

      const crop = $this.find('table').width()! - $this.width()! - 15;
      const sl = $this.find('.scrollable').scrollLeft()!;
      if (sl > 15) $this.addClass('scrollable-scrolled');
      else $this.removeClass('scrollable-scrolled');
      if ( crop > 0 && sl < crop ) $this.addClass('cropped');
      else $this.removeClass('cropped');
      if ( crop > 0 || sl > 15 ) {
        $this.removeClass('scrolled-middle');
        $this.removeClass('scrolled-bottom');
        const y = $(window).scrollTop()! + $(window).height()! / 2 - $this.offset()!.top;
        if (y > $this.height()! - 40) $this.addClass('scrolled-bottom');
        else if (y > 0) $this.addClass('scrolled-middle');
      }

    });
  }

  doScroll(tag: string) {
    const elem = document.getElementById(tag);
    if (!elem) {
      window.scrollTo(0, 0);
      return;
    }

    const e = $(elem);
    if (tag === 'pricing')
      e.next().find('.collapser.collapsed').trigger('click'); // need it for /resource/pricing to open collapsed table
    const supportPageOffset = window.pageYOffset !== undefined;
    const isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
    const scrolled = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    const offset = parseInt(e.attr('data-offset') || '0');
    const top = Math.floor(e.offset()!.top) + offset;

    const na = $('nwm-app');
    const bm = parseInt(window.getComputedStyle(na[0]).marginBottom);
    const bh = na[0].scrollHeight;
    const wh = window.innerHeight;
    na.css({marginBottom: top > bh-bm-wh ? (top-bh+wh) + 'px' : 0});

    if (top != scrolled) {
      $("html, body").animate({ scrollTop: top }, function() {
        $("html, body").delay(100).scrollTop(e.offset()!.top+ offset); //force scroll to the element in case something was still loading while animation (needed for IE)
      });
    }
  }

  scrollTo(tag = ''): void {
    const $this = this;
    if (tag === '') {
      window.scrollTo(0, 0);
      return;
    }
    const navigateTimer = setInterval(function(){
      if (!$this.showLoader) {
        clearInterval(navigateTimer);
        $this.doScroll(tag);
      }
    }, 100);
  }

}
